import { formatWhen } from './dutiShared';

const Row = ({ label, children }) => (
  <div className="flex gap-3 text-sm">
    <span className="w-28 shrink-0 text-muted-foreground">{label}</span>
    <span className="min-w-0 break-words">{children}</span>
  </div>
);

const MONEY_KEYS = new Set(['unit_cost', 'unit_price']);

const Lines = ({ items, cols }) => (
  <table className="w-full text-xs border rounded-md overflow-hidden">
    <thead className="bg-muted/60">
      <tr>{cols.map(([k, l]) => <th key={k} className="text-left px-2 py-1.5 font-medium">{l}</th>)}</tr>
    </thead>
    <tbody>
      {items.map((it, i) => (
        <tr key={i} className="border-t">
          {cols.map(([k]) => (
            <td key={k} className="px-2 py-1.5">
              {MONEY_KEYS.has(k) ? `GHS ${Number(it[k] || 0).toFixed(2)}` : String(it[k] ?? '—').replace(/_/g, ' ')}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

export const ActionDetails = ({ action }) => {
  const p = action.payload || {};
  return (
    <div className="space-y-2" data-testid={`duti-action-details-${action.action_id}`}>
      {action.action_type === 'draft_product' && p.product && (
        Object.entries(p.product).map(([k, v]) => <Row key={k} label={k.replace(/_/g, ' ')}>{String(v)}</Row>)
      )}
      {action.action_type === 'edit_product' && (
        <>
          <Row label="Product">{p.product_name}</Row>
          {Object.entries(p.changes || {}).map(([k, v]) => (
            <Row key={k} label={k.replace(/_/g, ' ')}>
              <span className="line-through text-muted-foreground mr-2">{String(p.before?.[k] ?? '—')}</span>{String(v)}
            </Row>
          ))}
        </>
      )}
      {action.action_type === 'draft_purchase_order' && (
        <>
          <Row label="Supplier">{p.supplier_name}</Row>
          <Lines items={p.items || []} cols={[['product_name', 'Item'], ['quantity_ordered', 'Qty'], ['unit_cost', 'Unit cost'], ['stock_on_hand', 'On hand']]} />
        </>
      )}
      {action.action_type === 'match_invoice' && (
        <>
          <Row label="Purchase order">{p.po_id} · {p.supplier_name}</Row>
          <Row label="Invoice">{p.invoice_number || '—'}</Row>
          <Lines items={p.rows || []} cols={[['product_name', 'PO item'], ['invoice_name', 'On invoice'], ['ordered_qty', 'Outstanding'], ['invoice_qty', 'Invoiced'], ['status', 'Result']]} />
          <p className="text-xs text-muted-foreground">Approving receives the invoiced quantities into stock against this PO.</p>
        </>
      )}
      {action.action_type === 'pos_pending_sale' && (
        <>
          <Lines items={p.items || []} cols={[['product_name', 'Item'], ['quantity', 'Qty'], ['unit_price', 'Price']]} />
          <Row label="Total">GHS {Number(p.total || 0).toFixed(2)}</Row>
          {action.status === 'pending' && <Row label="Stock held until">{formatWhen(action.expires_at)}</Row>}
        </>
      )}
    </div>
  );
};
